<template>
    <div class="notice-wrap">
        <div class="nav-top">
            <a class="return-a" @click="back"></a>
            <h3 class="nav-title">{{txtLang[langName]['noticeTitle']}}</h3>
        </div>

        <div class="notice-box">
            <ul class="notice-list" v-if = "isLoadingShow == false && noticeList.length > 0">
                <li v-for="(val, key) in noticeList">
                    <router-link :to="{name: 'Exchange', params:{'child_type': val.child_type}}">
                        <div class="notice-title">
                            <h5>{{val.title}}</h5>
                            <span>{{val.time}}</span>
                        </div>
                        <p class="notice-txt">{{val.content}}</p>
                    </router-link>
                </li>
            </ul>
            <noneBox v-else-if = "isLoadingShow == false && noticeList.length == 0" :noData="txtLang[langName]['noData']"></noneBox>
        </div>
        <Loading v-show="isLoadingShow"></Loading>
    </div>
</template>

<script>
    import Loading from './common/Loading';
    import noneBox from './common/None';

    export default {
        name: "messageList",
        components: {
            Loading,
            noneBox,
        },

        data(){
          return{
              isLoadingShow: false,
              noticeList: []
          }
        },

        methods: {
            back(){//返回上一层
                this.$router.go(-1);
            },

            /**
             * 新通知消除
             */
            clearRead(){
                let read = this.$route.params.noticeNum;
                if(read > 0){
                    this.axios.post(this.getHost() + '/notice/read?lan='+ this.langIndex + '&token=' + localStorage.getItem('guess_token')).then(
                        (response) => {

                        }
                    ).catch(
                        (response) => {
                            console.log(response)
                        }
                    )
                }
            },

            /**
             * 读取通知列表数据
             */
            loadData: function(options){
                var defaults = {
                    token: '',
                    lan: 'en',
                    success: null
                };

                defaults = Object.assign(defaults, options);

                const that = this;

                this.axios.get(this.getHost() + '/notice/list?token='+defaults.token+'&lan='+defaults.lan).then(
                    (response) => {
                        var re = response.data;

                        if(re.code == 200){
                            that.noticeList = re.data;
                        }
                    }
                ).catch(
                    (response) => {
                        console.log(response)
                    }
                )
            }
        },

        mounted(){//初始化
            this.clearRead();
            this.loadData({
                token: localStorage.getItem('guess_token'),
                lan: this.langIndex
            });
        }
    }
</script>

<style scoped>
    /* 顶部菜单 */
    .nav-top{width:100%;height:120px;text-align:center;background:#232048;position:fixed;z-index:110;top:0;left:0;}
    .return-a{display:inline-block;width:120px;height:120px;position:absolute;top:0;left:0;}
    .return-a:after{content:'';position:absolute;width:20px;height:20px;top:50%;left:50%;border-top:4px solid #fff;border-left:4px solid #fff;transform:translate(-50%,-50%) rotate(-45deg);-webkit-transform:translate(-50%,-50%) rotate(-45deg);-moz-transform:translate(-50%,-50%) rotate(-45deg);-o-transform:translate(-50%,-50%) rotate(-45deg);-ms-transform:translate(-50%,-50%) rotate(-45deg);}
    .nav-title{width:64%;margin:0 auto;line-height:120px;color:#fff;font-size:40px;font-weight:normal;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}

    /* 通知列表 */
    .notice-box{padding-top:120px;}
    .notice-list{padding:20px 22px;}
    .notice-list li{display:block;padding:32px;margin-top:20px;border-radius:12px;background:#3b3860;}
    .notice-title h5{display:inline-block;width:460px;color:#fff;font-size:30px;font-weight:normal;}
    .notice-title span{display:inline-block;color:#bbbabf;font-size:20px;}
    .notice-txt{line-height:24px;margin-top:20px;color:#bbbabf;font-size:20px;}
</style>


// WEBPACK FOOTER //
// src/components/messageList.vue